import { useMutation, useApolloClient, gql } from '@apollo/client'
import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { WarningIcon } from '@10xLabs/react-web/components/Icons/Warning'
import List from 'components/v2/List'
import Dropdown from 'components/v2/Dropdown'
import IconButton from 'components/v2/IconButton'
import { DotsIcon } from 'components/Icons/DotsIcon'
import { GTBookingClass } from 'gql/types.generated'
import { resolvers as bookingClassesResolvers } from 'resolvers/bookingClasses'

const DeactivateWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
`

const StyledWarningIcon = styled(WarningIcon)<TSFixMe>`
  margin-left: 10px;
`

const ACTIVATE_BOOKING_CLASS = gql`
  mutation ActivateBookingClass($id: ID!) {
    activateBookingClass(input: { id: $id })
  }
`

const ACTIVATE_LOCAL_BOOKING_CLASS = gql`
  mutation ActivateLocalBookingClass($id: ID!) {
    activateBookingClass(id: $id) @client
  }
`

const DEACTIVATE_BOOKING_CLASS = gql`
  mutation DeactivateBookingClass($id: ID!) {
    deactivateBookingClass(input: { id: $id })
  }
`

const DEACTIVATE_LOCAL_BOOKING_CLASS = gql`
  mutation DeactivateLocalBookingClass($id: ID!) {
    deactivateBookingClass(id: $id) @client
  }
`

export const BookingClassesActions = ({ bookingClass }: { bookingClass: GTBookingClass }): ReactElement => {
  const client = useApolloClient()
  client.addResolvers(bookingClassesResolvers)
  const [isOpenDropdown, setOpenDropdown] = useState(false)

  const toggleDropdown = (): TSFixMe => {
    setOpenDropdown(!isOpenDropdown)
  }

  const [activateLocalBookingClass] = useMutation(ACTIVATE_LOCAL_BOOKING_CLASS)
  const [activateBookingClass, { loading: activateLoading, error: activateError }] = useMutation(
    ACTIVATE_BOOKING_CLASS,
    {
      onCompleted() {
        activateLocalBookingClass({
          variables: {
            id: bookingClass.id
          }
        })
      }
    }
  )
  const [deactivateLocalBookingClass] = useMutation(DEACTIVATE_LOCAL_BOOKING_CLASS)
  const [deactivateBookingClass, { loading: deactivateLoading, error: deactivateError }] = useMutation(
    DEACTIVATE_BOOKING_CLASS,
    {
      onCompleted() {
        deactivateLocalBookingClass({
          variables: {
            id: bookingClass.id
          }
        })
      }
    }
  )

  const toggleBookingClassActivation = (): TSFixMe => {
    if (bookingClass.activatedAt) {
      deactivateBookingClass({
        variables: {
          id: bookingClass.id
        }
      })
    } else {
      activateBookingClass({
        variables: {
          id: bookingClass.id
        }
      })
    }
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator onClickAway={(): void => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} onClick={toggleDropdown} noBorder smallPadding />
        <Dropdown.Content open={isOpenDropdown} noIndicator left>
          <List.Container>
            <List.Item action onClick={toggleBookingClassActivation} loading={activateLoading || deactivateLoading}>
              <DeactivateWrapper>
                {!bookingClass.activatedAt ? (
                  <FormattedMessage id="dictionary.activate" defaultMessage="Activate" />
                ) : (
                  <FormattedMessage id="dictionary.deactivate" defaultMessage="Deactivate" />
                )}

                {(deactivateError || activateError) && <StyledWarningIcon />}
              </DeactivateWrapper>
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
    </>
  )
}
